<!--
 * @Author: your name
 * @Date: 2021-07-24 17:28:22
 * @LastEditTime: 2024-09-19 11:29:00
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\TerminalList.vue
-->

<template>
  <div class="terminal-list">
    <msg-dialog :dialogVisible="terminalListDV" @closeDialog="TerminalCD" dWidth="920px"
      :title="$t('PE.SelectTerminal')">
      <div v-loading="loading" :element-loading-text="$t('cswctl1')" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="equipment">
          <div class="equipment-left">
            <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
          </div>
          <div class="equipment-right">
            <!-- <div>搜索</div> -->
            <div class="device-table">
              <el-table ref="multipleTable" :data="deviceList" :row-key="(row) => row.id"
                @selection-change="deviceSelect" @row-click="tableRowClick">
                >
                <el-table-column type="selection" width="60" :reserve-selection="true"></el-table-column>
                <el-table-column prop="name" :label="$t('PE.TerminalName')" width="130"></el-table-column>
                <el-table-column prop="group_name" :label="$t('PE.Structure')"></el-table-column>
                <el-table-column prop="type_remark" :label="$t('PE.DeviceType')"></el-table-column>
                <el-table-column :label="$t('PE.DeviceStatus')">
                  <div slot-scope="scope" v-if="scope.row.run_state"
                    v-html="runState(scope.row.run_state, scope.row.group_run_status)"></div>
                  <div v-else>
                    <span style="color: #ea1a1a;">{{ $t('PE.Offline') }}</span>
                  </div>
                </el-table-column>
                <el-table-column prop="size_remark" :label="$t('PE.Resolution')"></el-table-column>
              </el-table>
            </div>
            <div class="flex-b-c device-control">
              <div>
                <el-checkbox v-model="selectAll" @change="changeAll"
                  :indeterminate="selectAll && deviceSelectList.length < current">{{ $t('terminal.allSelect') }}</el-checkbox>
                <span style="padding: 16px;"
                  v-show="deviceSelectList.length > 0 || selectNum > 0">{{ $t('terminal.selected') }}({{
                    selectAll ? selectNum :deviceSelectList.length}})</span>
              </div>
              <div>
                <el-input placeholder="请输入终端名称" v-model="keyword" size="mini">
                  <i slot="suffix" class="el-input__icon el-icon-search icon" @click="getKeywordList"></i>
                </el-input>
              </div>
              <div>
                <pagination :page="this.page" :pagerCount="5" :current="current" :limit="limit"
                  @currentChange="currentChange"></pagination>
              </div>
              <!-- <span></span> -->
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="button">
            <el-button round @click="cancel">{{ $t('basics.Cancel') }}</el-button>
            <el-button round type="primary" @click="confirm" :disabled="this.deviceSelectList.length == 0">{{
              $t('basics.Confirm') }}</el-button>
          </div>
          <div class="append">
            <div class="checkb">
              <el-checkbox v-model="adapterScreen">{{ $t('PE.AdaptiveScreen') }}</el-checkbox>
            </div>
            <el-select v-model="isAppend" size="mini" style="width: 120px;" :placeholder="$t('basics.PleaseSelect')"
              v-if="append">
              <el-option v-for="item in publishType" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </msg-dialog>
    <msg-dialog :dialogVisible="publishNameDv" @closeDialog="publishNameCD" :title="$t('nswct01')" :modalAppend="false">
      <div class="flex-a-c" style="margin-bottom: 16px;">
        <div style="width: 100px">{{ $t('nswct01') }}: </div><el-input v-model="publishName"
          :placeholder="$t('nswct02')"></el-input>
      </div>
      <div class="flex-a-c">
        <el-button round @click="publishNameCD">{{ $t('basics.Cancel') }}</el-button>
        <el-button round type="primary" @click="confirm">{{ $t('basics.Confirm') }}</el-button>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
// this.$emit("publishTerminal", this.deviceSelectList, this.adapterScreen, this.isAppend);
/**
 * @description: 设备选择发布
 * @param {选中设备列表} 参数1
 * @param {是否自适应屏幕有} 参数2
 * @param {覆盖追加发布}} 参数3
 * @return {*}
 */

import MsgDialog from '@/components/basics/FormDialog'
import { mPagination } from "@/components/basics/mixins";
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import { runStateInfo } from "@/assets/scripts/runState"
import { changeDeviceStateName } from "@/assets/scripts/changeDeviceStateName";
export default {
  name: 'TerminalList',
  mixins: [mPagination],
  props: {
    terminalListDV: {
      type: Boolean,
      default: false
    },
    diffIsAppend: {
      type: Number,
      default: 0
    },
    append: {
      type: Boolean,
      default: false
    },
    defaultPName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      groupList: [],
      deviceList: [],
      deviceAllList: [],
      deviceSelectList: [],
      adapterScreen: false,
      isAppend: '0',
      notificationId: null,
      selectAll: false,
      loading: false,
      selectNum: 0,
      keyword: "",
      publishType: [{
        value: '0',
        label: this.$t('cswctl2')
      }, {
        value: '1',
        label: this.$t('cswctl3')
      }],
      publishNameDv: false,
      publishName: "",
    }
  },
  mounted() {
    this.getGroupList();
    this.getDeviceList();
  },
  methods: {
    init() {
      this.selectAll = false;
      this.loading = false;
      this.selectNum = 0;
      this.deviceSelectList = [];
      this.deviceList = [];
      this.deviceAllList = [];
    },
    versionsHint() {
      this.notificationId = this.$notify({
        title: this.$t('PE.Tip'),
        dangerouslyUseHTMLString: true,
        type: 'warning',
        message: this.$t('PE.version'),
        duration: 0
      });
    },
    publishNameCD() {
      this.publishNameDv = false;
      this.publishName = '';
    },
    cancel() {
      this.$emit("publishTerminal", []);
    },
    async confirm() {

      if (this.defaultPName && this.publishName === "") {
        this.publishName = this.defaultPName;
        this.publishNameDv = true;
        return;
      }

      this.publishNameDv = false;

      // eslint-disable-next-line no-unused-vars
      let append = 0;
      this.append ? append = this.isAppend : append = this.diffIsAppend;
      // eslint-disable-next-line no-unused-vars
      let list = this.deviceSelectList;

      if (this.selectAll) {
        if (this.deviceAllList.length - this.deviceSelectList.length === 0) {
          await this.getDeviceSelectList("all").then((res) => { list = res });
        } else {
          let devices = this.deviceAllList.filter((d) => {
            return this.deviceSelectList.findIndex((s) => s.id === d.id) === -1;
          });
          await this.getDeviceSelectList("filter", devices).then((res) => { list = res });
        }
      }
      this.loading = true;
      this.$emit("publishTerminal", list, this.adapterScreen, append, this.publishName);
    },
    // eslint-disable-next-line no-unused-vars
    async getDeviceSelectList(type, devices = []) {
      let list = [];
      await this.$http.post('/admin/device/selectList', { device_select_mode: type, group_ids: this.groupIds, devices_info: encodeURIComponent(JSON.stringify(devices)) }, data => {
        list = data ? data : [];
      });
      return list;
    },
    TerminalCD() {
      this.adapterScreen = false;
      this.publishType = 0;
      this.$emit("publishTerminal", []);
      //this.$emit("publishTerminal", []);
      // if (isConfirm) {
      // 	this.$emit("publishTerminal", this.deviceSelectList, this.adapterScreen, this.isAppend);
      // } else {
      // 	this.$emit("publishTerminal", []);
      // }
    },
    //组织结构切换重新加载关联设备
    getAssets(ids) {
      this.page = 1;
      if (ids.type === "GROUP") {
        this.groupIds = ids.ids;
      }
      this.changeAll(false);
      this.getDeviceList();
      // 当组织结构发生切换事件时所选择的终端设备全部取消勾选；
      // this.multipleSelection = [];
      // this.equipment = [];
    },
    getKeywordList() {
      this.changeAll(false);
      this.getDeviceList();
    },
    getGroupList() {
      this.$http.post("/admin/access/groupList", {}, data => {
        this.groupList = data;
      });
    },
    currentChange(val) {
      this.page = val;
      this.getDeviceList();
    },
    runState(rt, gt) {
      let rti = runStateInfo(rt, gt);
      rti = changeDeviceStateName(rti);
      //console.log(rti)
      return `<span style="color: ${rti.stateColor};">${this.$t(rti.stateName)}</span>`;
    },
    // 区分设备类型Kommander/Kommander
    // type_id: 2,
    // type_id: 1,
    // getDeviceList(device = { group_ids: this.groupIds, limit: 12, type_id: 2, page: this.page }) {
    getDeviceList(device = {
      group_ids: this.groupIds,
      limit: 12,
      page: this.page,
      key_word: this.keyword
    }) {
      this.$http.post("/admin/device/list", device, data => {
        this.deviceList = data.list ? data.list : [];
        this.selectAll && this.deviceList.forEach(row => {
          this.$nextTick(() => {
            let index = this.pushDeviceAllList(row);
            if (index === -1) {
              this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
        });
        this.current = parseInt(data.count);
      });
    },
    pushDeviceAllList(row) {
      let index = this.deviceAllList.findIndex(d => d.id == row.id);
      index === -1 && this.deviceAllList.push(row);
      return index;
    },
    changeAll(val) {
      if (val) {
        this.selectNum = this.current;
        this.deviceList.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
        this.deviceAllList.push(...this.deviceList);
      } else {
        this.selectAll = false;
        this.selectNum = 0;
        this.deviceAllList = [];
        this.$refs.multipleTable.clearSelection();
      }
    },
    deviceSelect(val) {
      this.deviceSelectList = val;
      this.selectAll && this.$nextTick(() => {
        this.selectNum = this.current - (this.deviceAllList.length - this.deviceSelectList.length);
        // console.log(this.deviceSelectList.length);
        // console.log(this.deviceAllList.length);
      });
    },
    tableRowClick(row, column, event) {
      console.log(row, column, event);
      // this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
  },
  watch: {
    terminalListDV: {
      handler(nVal) {
        console.log(nVal);
        this.init();
        this.getGroupList();
        this.getDeviceList();
        // if (nVal) {
        //   this.versionsHint();
        // } else {
        //   this.notificationId.close();
        // }
      }
    }
  },
  components: {
    MsgDialog,
    trees,
    pagination
  }
}
</script>

<style lang="scss" scoped>
.terminal-list {
  .equipment {
    display: flex;
    height: 500px;

    .equipment-left {
      flex: 0 0 240px;
      border: 1px solid #edfbff;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .equipment-right {
      margin-left: 8px;
      flex: 1;
      border-radius: 8px;

      .device-table {
        height: calc(100% - 40px);
        overflow-y: auto;
      }

      .device-control {
        position: relative;

        /deep/ .el-input__inner {
          border-radius: 20px;
        }
      }
    }

    /deep/ .el-table__header-wrapper {
      .cell {
        font-size: 18px;
        color: #2fb3ff;
      }

      th:last-child>.cell {
        text-align: center;
      }
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    position: relative;

    .button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .append {
      width: 300px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>

<style>
.el-notification {
  z-index: 3000 !important;
}
</style>
